import ServicesNames from 'app-constants/service.names';
import { CollectionService } from './base.service';

class Service extends CollectionService {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(serviceName: string) {
    super(serviceName);
  }
  getUserProfile = () => this.client.get(ServicesNames.USER_PROFILE);
  updateUserConfig = (userConfig) =>
    this.client.put(`${ServicesNames.USERS}/config`, userConfig);
  logout = (token?: string) =>
    this.client.post(ServicesNames.USER_LOGOUT, {
      headers: { Authorization: 'Bearer ' + token },
    });
}

export default new Service(ServicesNames.AUTH_LOGIN);
